import { cx } from "@jugl-web/utils";
import { FC, HTMLProps } from "react";

export const Divider: FC<HTMLProps<HTMLDivElement>> = ({
  className,
  ...props
}) => <div className={cx("bg-dark-100 h-px w-full", className)} {...props} />;
